export enum ServiceNotificationType {
  INFO = 'INFO',
  ALERT_ACTION = 'ALERT_ACTION',
  INFO_ACTION = 'INFO_ACTION',
  URGENT = 'URGENT',
}

export const ServiceNotificationIcon = {
  ACTION: 'icon-actions',
  PENDING: 'hour-glass',
  COMPLETE: 'icon-circle-check',
  LOCKED: 'lock',
  DELETED: 'trash',
} as const;

export enum ServiceNotificationState {
  ACTION = 'ACTION',
  PENDING = 'PENDING',
  COMPLETE = 'COMPLETE',
  LOCKED = 'LOCKED',
  DELETED = 'DELETED',
}

export interface ServiceNotificationItem {
  id: string;
  key?: string;
  copy1: string;
  copy2: string;
  copy3: string;
  type: ServiceNotificationType;
  route?: string;
  read: boolean;
  state: ServiceNotificationState;
  createTs: string;
}

export interface ServiceNotificationsState {
  notifications: ServiceNotificationItem[];
  loading: boolean;
  error: string | null;
}


